import { render, staticRenderFns } from "./dbTableData.vue?vue&type=template&id=015be7da&scoped=true&"
import script from "./dbTableData.vue?vue&type=script&lang=js&"
export * from "./dbTableData.vue?vue&type=script&lang=js&"
import style0 from "./dbTableData.vue?vue&type=style&index=0&id=015be7da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015be7da",
  null
  
)

export default component.exports